module.exports = __webpack_public_path__ + "static/img/jiugonggeBg.5ca91647.png";